import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {BaseSupplier} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getOptionsFromSuppliers = (suppliers: BaseSupplier[] | Nullish): Option[] => {
  if (isNil(suppliers)) {
    return [];
  }

  return suppliers.map((supplier) => ({
    label: supplier.name,
    value: supplier.id,
  }));
};
